import Popup from 'reactjs-popup'
import ReactPlayer from 'react-player'
import {IoMdClose} from 'react-icons/io'
import './index.css'

const MovieItem = ({movieDetails}) => {
  const {thumbnailUrl, videoUrl} = movieDetails

  return (
    <div className="movie-item">
      <Popup
        modal
        trigger={
          <button className="thumbnail-button" type="button">
            <img
              src={thumbnailUrl}
              alt="thumbnail"
              className="thumbnail-image"
            />
          </button>
        }
        className="popup-content"
      >
        {close => (
          <div className="popup-body">
            <button
              type="button"
              className="close-button"
              onClick={() => close()}
              data-testid="closeButton"
              aria-label="close"
            >
              <IoMdClose size={24} />
            </button>
            <div className="player-wrapper">
              <ReactPlayer url={videoUrl} controls width="100%" height="100%" />
            </div>
          </div>
        )}
      </Popup>
    </div>
  )
}

export default MovieItem
